export function toUpper(param: string) {
    return (param || '').toUpperCase();
}
